import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Section = styled.section`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 15px;
  }
`;

export const Title = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 18px;
  font-weight: 500;
  padding: 10px 0;
`;

export const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 25px 0 30px 0;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 20px 0 25px 0;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 40px;
`;
